<div
  class="filter surface-elevated w-100 pb-plus {{ classes() }}"
  [ngStyle]="componentStyle()"
>
  <div
    (click)="toggleFilter.emit()"
    class="filter-item px-low py-tiny c-2 cursor-pointer d-flex gap-tiny align-items-center justify-content-start {{
      isActive() ? classesForActiveItem : classesForDeActiveItem
    }}"
  >
    <ngx-chip
      [id]="'allFilters'"
      [leadingIcon]="buttonIcon()"
      [disableAnimations]="true"
      [size]="size()"
      [disableClick]="true"
      [label]="buttonLabel()"
      [pressed]="false"
    ></ngx-chip>
  </div>
  <div class="filter-box">
    <common-ui-components-horizontal-scroll [classes]="'pl-atom gap-tiny'">
      <ng-content></ng-content>
    </common-ui-components-horizontal-scroll>
  </div>
</div>
